import { CallableInput } from "Components/Shared";
import FormSubmit from "Components/Shared/FormSubmit";
import TimePicker from "Components/Shared/TimePicker";
import { Field, Formik } from "formik";
import { useDevice } from "Hooks/Endpoints";
import React from "react";
import { Form } from "semantic-ui-react";

const TimeRangeRouterEdit = () => {
  const { update, device } = useDevice();

  return (
    <Formik
      initialValues={device}
      onSubmit={(values, actions) => {
        update(values);
      }}
    >
      {(props) => (
        <Form onSubmit={props.handleSubmit}>
          <Field name='name' label='Name' component={CallableInput} />
          <Field
            name='extension'
            label='Extension'
            placeholder='100'
            type='number'
            component={CallableInput}
          />
          <TimePicker name='timeRangeRoute.start' label='Start Time' />
          <TimePicker name='timeRangeRoute.end' label='End Time' />
          <FormSubmit name='Create' errors={props.errors} />
        </Form>
      )}
    </Formik>
  );
};

export default TimeRangeRouterEdit;
